import React, { useContext, useState, useEffect, useRef } from 'react'
import '../../styles/preparepdf.css'

import Sign from '../../assets/signature.png'
import Stamp from '../../assets/stamp.png'
import { ShareContext } from '../../context/ShareContext'

import { time } from '../../data/time'
import { useNavigate, useLocation, Link } from 'react-router-dom'
import * as Constants from '../../constants';
import BackLoader from '../../components/backloader'
import Seal from '../../assets/seal.png';
import Sign2 from '../../assets/sign.png';

import JisPrompt from '../../components/jisprompt'
import JisAlert from '../../components/jisalert'
import { green, red } from '@mui/material/colors'
import moment from 'moment'
import DynamicIcon from '../dynamicicon'
import JisButton from '../controls/jisButton'


function JisPreparePdf({pdfdoc,docInfo, isLegal=true, onInstumentAppended, doctype="document"}) {

    const { sweared, isCfo, isThirdOpt, setWhichUpload, profile, token,frequentData,setIsExpired } = useContext(ShareContext)

    const item = docInfo;
 
     const cashier_stamp=`${Constants.rooturl}/resources/special/cashier_stamp.png`; //image path
    const urlSaveInst = `${Constants.apiUrl}/filing/uploadinstrument`;
    const urlInstrument=`${Constants.apiUrl}/filing/instrument`;
    const cashierSeal_path=`${Constants.rooturl}/resources/special`;
    

const [currectdoc, setCurrentDoc]=useState(pdfdoc);//
    const [cfoWarn, setCfoWarn] = useState(false)
    const [isDialog, setIsDialog] = useState(false)
    const [doc, setDocument] =useState({uplines:[],uplinesigns:[]})
    const [isLoading,setIsLoading]= useState(false);
    const [posPoint, setPosPoint] = useState({}); //this is for items that are yet added passport 1, Seal 2, Signature 3  {x--cord,y - cord,show bool,docid  instype, imgurl} 
    const [seal, setSeal]=useState('');
    const [passport, setPassport] =useState('');
    const [sign, setSign] =useState('');
    const [initial, setInitial] =useState('');
    const [stamp, setStamp] =useState('');
    const [pageIndex, setPageIndex]=useState(0);
    const [isSaved, setIsSaved] =useState(false);
    const [cashier_seal, setCashierSeal]=useState('')
   const [permissionList, setDocPermissionList]=useState(new Set());

       const imageRef = useRef(null);
   
    const [currentdate, setCurrendate] = useState(new Date());
     const [timestamp, setTimestamp] = useState(moment(currentdate).format("YYYY-MM-DD hh:mm a"));
   //load documents first, then load one by one
   const [posId, setPosId] =useState(0); //this is the main guy that is doing the selection
   const [dstart, setDStart]=useState({isDragging: false});
   const [imgs, setImgs]=useState([]);
   const [activeFile,setActiveFile] =useState({});

   const needpermission="Document saved successfully! Wait for the CFO to commission your document ";
   const noneedpermission="Document saved successfully! Wait for the CFO to initial your document";
   const cfoMsg=""
     const finalmsgcase=`You have worked on all document(s), the case will now move to Process Section Assessors' Queue `;
   const finalmsgaffidavit="You have worked on the affidavit. The process is completed now";
   const finalmssheriff=`Document processed successfully! You have worked on Service Sheriff affidavit. `;
   const finalsettlement=`Term of settlement processed successfully! `;
  
  // const permissionList=item.caseType=='adr'?Constants.DocPermissionList_ADR:Constants.DocPermissionList;
 const prepareWritoffifa="Document saved successfully! Wait for the ACR for Review ";
   const finalwritoffifa=`Case is going to Head of Process for further review`;
   const finalwarrant=`Case is going to Head of Process for Notice of Attachment`;


   const onSaveInst=()=>{
        onUploadIns();
   }

   const [imgPrev, setImgPrev]=useState ({data:'', type:'', open:false});
   const [alert, setAlert]=useState ({open:false,title:'', subtitle:''})
   const [prompt, setPrompt]=useState ({open:false,title:'', subtitle:''})

   var pageRef=useRef(null);

    const navigate = useNavigate()

 const onOk=()=>{
    setAlert({...alert,open:false});
 }
 const onGotoDashboard = () => {
    setAlert({ ...alert, open: false });
    console.log("on going to dashboard");
    console.log(item, "item here");
 
    if(item.type=='affidavit'){
        navigate("/cfo-affidavits");
       }else if (doctype == "sheriff") {
      navigate("/cfo-e-swearing-sheriff");
    }else if(doctype=='service-sheriff-sub') {
      navigate("/cfo-e-swearing-sheriff-substituted");
    }
    else if (doctype == "sheriff") {
      navigate("/cfo-e-swearing-sheriff");
    }
    else if (doctype== "writ-of-fifa"){
             navigate("/acr-writ-of-fifa");
       }
       else if (doctype== "writ-warrant"){
             navigate("/judge-warrants");
       }
        else {
      navigate("/cfo-e-swearing");
    }
  };
 const onfinalMsg = () => {
    if (item.type == "affidavit") {
      return finalmsgaffidavit;
    } else if (doctype == "sheriff") {
      return finalmssheriff;
    } else if (doctype == "settlement") {
      return finalsettlement;
    } else if (doctype == "service-sheriff-sub")
      return "You have worked on all doument(s). The case will now move to Case manger Queue";
     else if (doctype== "writ-of-fifa"){
       return finalwritoffifa;
     }
     else if (doctype== "writ-warrant"){
       return  finalwarrant
     }
      else {
      return finalmsgcase;
    }
  };
const onSaveMsg=()=>{
            if((permissionList.has(currectdoc?.upline?.gazetteItemId)||  item.type=='affidavit')){
                return needpermission;
            }else if(doctype=='sheriff'){
               return finalmssheriff
            }else if(doctype=='settlement'){
               return finalsettlement
              
            }else if(doctype=='service-sheriff-sub')
                return "Document saved successfully! "; 
           else if (doctype== "writ-of-fifa"){
             return prepareWritoffifa;
       }
       
                else{
               return needpermission
            }
        }
    const confirmCaseDoc = () => {
        navigate('/upload/documents');
        setWhichUpload('Third')
    }

    useEffect(() => {
       
        onLoadInstrument();
       console.log('am here in usefect in preparePdf************');
       console.log(pdfdoc)
        setCurrentDoc(pdfdoc)
       setImgs([]);
      setPosId(0);
      setDStart({isDragging: false})
      setCashierSeal(`${cashierSeal_path}/cashier_seal_${pdfdoc.upline?.id}.png`) 
      onLoadPermissions();
      }, [pdfdoc]);
 const onLoadPermissions= async()=>{
            //for account registration
            
            try {
                const resp = await fetch(`${Constants.apiUrl}/setup/gazette-lines-permission`, { 
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                  },
                });
                const data = await resp.json();
                if(data.code==0){
                    console.log('list of permissions')
                    console.log(data.ids);
                    setDocPermissionList(new Set(data.ids) );
                }
               
              } catch (error) {
               
                console.error(error);
                
              }
        }
       useEffect(() => {
       
        if(imageRef.current!=null){
            handleImageLoad();
        }
        
      }, [imageRef.current]);

      useEffect(() => {
        if (!pageRef.current) {
          // we do not initialize the observer unless the ref has
          // been assigned
          return;
        }
    
        // we also instantiate the resizeObserver and we pass
        // the event handler to the constructor
        const resizeObserver = new ResizeObserver(() => {
            console.log('in resize observer ')
            const divPos=pageRef?.current?.getBoundingClientRect();
            const start={
            
             initialX: divPos?.x,
             initialY: divPos?.y,
     
           }
           console.log('at use effect calculate init position');
      console.log(start);

           setDStart(start);
        });
        
        // the code in useEffect will be executed when the component
        // has mounted, so we are certain observedDiv.current will contain
        // the div we want to observe
        resizeObserver.observe(pageRef.current);
    
    
        // if useEffect returns a function, it is called right before the
        // component unmounts, so it is the right place to stop observing
        // the div
        return function cleanup() {
          resizeObserver.disconnect();
        }
      },
      // only update the effect if the ref element changed
      [pageRef.current])
    


    //drag issue
    const onDrag = (e) => {
        /* dragCarer.current = position;*/
      
        const _start={
            ...dstart, x:e.clientX, y:e.clientY
          }
          setDStart(_start);
        
       
      };

      const scheduleDragEnter = (e,day, position) => {
        // dragOver.current = {day,position};
       
        e.preventDefault();
      };

      
    //passport 1, Seal 2, Signature 3 
    const onAppendPassport=()=>{
      /*   if(pageIndex != currectdoc.filenames.length-1){
            setAlert(  {open:true,title:'Append ', subtitle:'You can only append to last page', onOk});
          return;
        } */

         if(passport=='')
        {
          setAlert(  {icon:'warning',open:true,title:'Append Passport', subtitle:'Please upload your passport', onOk});
          return;
        } 

        var _pos={...posPoint};
        _pos[1]={x:0,y:0,show:true,  instype:'Passport', imgurl:passport,id:1, start:{} , pageIndex}
        setPosId(1)
        setPosPoint(_pos);
        setImgs(Object.values(_pos)) 
        console.log('the value');
        console.log(_pos);
    }

    const onAppendSeal=()=>{
       if(profile.role== 'LegalCounsel'){
        if(permissionList.has(currectdoc.upline?.gazetteItemId) && !currectdoc.upline?.allowSeal){
            setAlert(  {icon:'warning',open:true,title:'Append ', subtitle:'Wait for the CFO to authorize appending a seal on the document. This approval will be granted during the scheduled virtual call', onOk});
          return;
        } 
       }else{
        if(permissionList.has(currectdoc.upline?.gazetteItemId) && !currectdoc.upline?.allowSeal){
            setAlert(  {icon:'warning',open:true,title:'Append ', subtitle:'Allow Legal Counsel to append seal before you, if you sure you have as CFO then. Please Next and Previous to same file to refresh', onOk});
          return;
        } 
       }
         if(seal=='')
        {
          setAlert(  {icon:'warning',open:true,title:'Append Seal', subtitle:'Please upload your seal', onOk});
          return;
        } 

        console.log(imgs);
        var _pos={...posPoint};
        _pos[2]={x:0,y:0,show:true,  instype:'Seal', imgurl:seal,id:2,start:{}, pageIndex  }
        setPosId(2)
        setPosPoint(_pos);
        setImgs(Object.values(_pos)) 
        console.log('the value');
        console.log(_pos);
    }

    const onAppendCashierSeal=()=>{
        if(profile.role== 'LegalCounsel' || profile.role== 'Customer'){
            return;
        }

         console.log(imgs);
         var _pos={...posPoint};
         _pos[10]={x:0,y:0,show:true,  instype:'Cashier Seal', imgurl:cashier_seal,id:10,start:{}, pageIndex  }
         setPosId(10)
         setPosPoint(_pos);
         setImgs(Object.values(_pos)) 
         console.log('the value');
        console.log(_pos);
     }
     const onAppendCashierStamp=()=>{
        if(profile.role== 'LegalCounsel' || profile.role== 'Customer'){
            return;
        }


         console.log(imgs);
         var _pos={...posPoint};
         _pos[11]={x:0,y:0,show:true,  instype:'Cashier Stamp', imgurl:cashier_stamp,id:11,start:{}, pageIndex  }
         setPosId(11)
         setPosPoint(_pos);
         setImgs(Object.values(_pos)) 
         console.log('the value');
        console.log(_pos);
     }

    const onAppendSignature=()=>{
        if(permissionList.has(currectdoc.upline?.gazetteItemId) && !currectdoc.upline?.allowSign){
          //  setAlert(  {open:true,title:'Append ', subtitle:'Wait for the CFO to authorize appending a signature on the document. This approval will be granted during the scheduled video virtual call". if you are sure the CFO has approved. Please click Next and Previous to the same file to refresh', onOk});
         setAlert(  {icon:'warning',open:true,title:'Append ', subtitle:'Wait for the CFO to authorize appending a signature on the document. This approval will be granted during the scheduled virtual call', onOk});
          return;
        } 

        if(sign=='')
        {
          setAlert(  {icon:'warning',open:true,title:'Append Signature', subtitle:'Please upload your Signature', onOk});
          return;
        } 
        var _pos={...posPoint};
        _pos[3]={x:0,y:0,show:true,  instype:'signature', imgurl:sign,id:3,start:{}, pageIndex  }
        setPosId(3)
        setPosPoint(_pos);
        setImgs(Object.values(_pos)) 

        console.log('the value');
        console.log(_pos);
    }

    const onAppendInitial=()=>{
       
        if(initial=='')
        {
          setAlert(  {icon:'warning',open:true,title:'Append Initial', subtitle:'Please upload your Initial', onOk});
          return;
        } 
        var _pos={...posPoint};
        _pos[6]={x:0,y:0,show:true,  instype:'initial', imgurl:initial,id:6,start:{}, pageIndex  }
        setPosId(6)
        setPosPoint(_pos);
        setImgs(Object.values(_pos)) 

        console.log('the value');
        console.log(_pos);
    }

    const onAppendStamp=()=>{
       

        if(stamp=='')
        {
          setAlert(  {icon:'warning',open:true,title:'Append Stamp', subtitle:'Please upload your Stamp', onOk});
          return;
        } 
        var _pos={...posPoint};
        _pos[4]={x:0,y:0,show:true,  instype:'stamp', imgurl:stamp,id:4,start:{}, pageIndex  }
        setPosId(4)
        setPosPoint(_pos);
        setImgs(Object.values(_pos)) 
        console.log('the value');
        console.log(_pos);
    }
    const onAppendTimestamp=()=>{
       
        //5 for timestamp

      
        var _pos={...posPoint};
        _pos[5]={x:0,y:0,show:true,  instype:'timestamp', imgurl:'',id:5,start:{}, pageIndex, timestamp  }
        setPosId(5)
        setPosPoint(_pos);
        setImgs(Object.values(_pos)) 
        console.log('the value');
        console.log(_pos);
    }
    const onAppendTimestamp2=()=>{
       
        //5 for timestamp

      
        var _pos={...posPoint};
        _pos[7]={x:0,y:0,show:true,  instype:'timestamp', imgurl:'',id:7,start:{}, pageIndex, timestamp  }
        setPosId(7)
        setPosPoint(_pos);
        setImgs(Object.values(_pos)) 
        console.log('the value');
        console.log(_pos);
    }


    const onMoveInstru=(ev)=>{
        console.log(ev);

       console.log(ev.pageX);
       console.log(ev.pageY);
       if(posId>0){
        
       var _pos={...posPoint};
       var aa=_pos[posId];
       _pos[posId]={...aa, x:ev.pageX,y:ev.pageY}
       setPosPoint(_pos);
       setImgs(Object.values(_pos)) 
       }
       

    }

 
    const onDragStart = (e, instid) => {
        const containerRect = e.currentTarget.getBoundingClientRect();
    
        if (!dstart.isDragging) {
            const start = {
                ...dstart,
                isDragging: true,
                offsetX: e.clientX - containerRect.left,
                offsetY: e.clientY - containerRect.top,
                initialX: e.clientX,
                initialY: e.clientY
            };
            setDStart(start);
        }
    
        console.log("About main div:");
        console.log(pageRef.current.getBoundingClientRect());
    };
    
    const onDragEnd = (e, instid) => {
        console.log(imgs);
        console.log("Drag end");
        console.log(`x: ${e.clientX}, y: ${e.clientY} | init x: ${dstart.initialX}, init y: ${dstart.initialY}`);
    
        let updatedPosId = posId;
    
        if (updatedPosId !== instid) {
            setPosId(instid);
            updatedPosId = instid;
        }
    
        const updatedPositions = { ...posPoint };
        const currentItem = updatedPositions[updatedPosId] || {};
    
        const divPos = pageRef.current.getBoundingClientRect();
        console.log("The main div object size:");
        console.log(divPos);
    
        const x = e.clientX - divPos.x - dstart.offsetX;
        const y = e.clientY - divPos.y - dstart.offsetY;
    
        if (x > 650) {
            console.log("Item is out of bounds. Removing...");
            delete updatedPositions[updatedPosId];
            setPosPoint(updatedPositions);
            setImgs(Object.values(updatedPositions));
            return;
        }
    
        console.log(`Calculated X: ${x}, Y: ${y}`);
    
        updatedPositions[updatedPosId] = { ...currentItem, x, y };
        console.log(updatedPositions[updatedPosId]);
    
        setPosPoint(updatedPositions);
        setImgs(Object.values(updatedPositions));
    };
    

    const previewImage= async (event, inst)=> {
        console.log("file read");
        const input = event.target;
       // const preview = document.getElementById('preview');
        console.log(input);
        if (input.files && input.files[0]) {
            var b64=await Constants.toBase64(input.files[0]);
            setImgPrev({open:true,data:b64,type:inst, title:"Upload "+inst,file:input.files[0], onCancel:()=>setImgPrev({...imgPrev,open:false}) });
            setActiveFile({open:true,data:b64,type:inst, title:"Upload "+inst,file:input.files[0], onCancel:()=>setImgPrev({...imgPrev,open:false}),onOk:onSaveInst  });
            console.log("file read");

          /* const reader = new FileReader();
  
          reader.onload = function (e) {
            console.log('file read now... ')
           // preview.src = e.target.result;
            setImgPrev({...imgPrev,open:true,data:e.target.result,type:inst, title:"Upload "+inst, });
          };
  
          reader.readAsDataURL(input.files[0]); */
        }
      }

      const onAgree=()=>{
        setImgPrev({...imgPrev,open:false});
        onSaveInst();
      }
    const onUploadIns= async()=>{
        console.log('imgPrev data');
        console.log(imgPrev);
     
      
            setIsLoading(true);    
        //setImgPrev({...imgPrev,open:true,data:e.target.result,type:inst, title:"Upload "+inst, });
            var ext=imgPrev.file.name.split('.')[1];
            var rdata={base64: imgPrev.data.split(',')[1],instType:imgPrev.type,ext,changereason:'Initial'};
            // Sending the FormData using fetch
            fetch(urlSaveInst, {
            method: 'POST',
            body: JSON.stringify(rdata),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            })
            .then(response => response.json())
            .then(data => {
                setIsLoading(false); 
                if(data.code==0){
                    //saved already
                    setImgPrev({...imgPrev,open:false})
                   setAlert( {...alert, title:imgPrev.type, open:true, subtitle:`Saved ${imgPrev.type} successfully`, onOk })
                   console.log(`data instPath ${data.instPath} , imgPrev.type ${imgPrev.type}`);
                   onSetImg(data.instPath,imgPrev.type);
                }else if(data.code==-10){
                setIsExpired(true);
            }
            })
            .catch(error => {
                console.error('Error:', error)
                setIsLoading(false); 
            });
    }

    const onAppendOnServer= ()=>{
            setPrompt({open:false});
              
            const url = `${Constants.apiUrl}/filing/appendInstrument/${currectdoc.upline?.id}/${dynamicWidth}/${staticHeight}/${aspectRatio}/${isLegal}`;
            var ll=[];
            for( const x of imgs ){
                var l= {InstrumentType: x.instype,x:x.x,y:x.y, url:x.imgurl , pageIndex:x.pageIndex, timestamp};
                ll.push(l);
            }
            

            if(ll.length==0){
                setAlert( {...alert,icon:'warning', title:imgPrev.type, open:true, subtitle:`Its either you did not append any instrument or there is no other instrument required.`, onOk })
                return;
            }
            setIsLoading(true); 
            console.log('server positioning *****************');
            console.log(ll);
            // Sending the FormData using fetch
            fetch(url, {
            method: 'POST',
            body: JSON.stringify(ll),
            headers: {
            'Content-Type': 'application/json',
           Authorization: `Bearer ${token}`,
            },
            })
            .then(response => response.json())
            .then(data => {
                setIsLoading(false); 
                if(data.code==0){
                    //saved already
                    setImgPrev({...imgPrev,open:false})
                    //if profile.role=='legal councel'
                    if(isLegal){
                        setAlert( {...alert, open:true, title:'Save Document', open:true, subtitle:onSaveMsg(), onOk })
                    }else{
                        if(data.incompleted==0){
                            setAlert( {...alert,open:true, title:'Process Document', open:true, subtitle:onfinalMsg(), onOk: onGotoDashboard })
                        }else{
                            setAlert( {...alert,open:true, title:'Process Document', open:true, subtitle:`Processed Successfully. Document remain to be processed ${data.incompleted}`, onOk })
                        }
                    }
                    onInstumentAppended(data);
                UpdateInst(currectdoc.upline?.id);
                setPrompt({...prompt, open:false, });


           

                }else if(data.code==-10){
                setIsExpired(true);
            }
            })
            .catch(error => {
                console.error('Error:', error)
                setIsLoading(false); 
            });
    }

    const UpdateInst=(id)=>{ //the id of the upline
         
            var  uplines = doc.uplines;
                var pass= posPoint[1];
              var seal= posPoint[2];
              var sign= posPoint[3];
           // var updatedup 
            if(isLegal){
              

              if(pass!=null){
                uplines= uplines.map(l=>l.id==id?{...l,passportPath:'uploaded'}:l)
              }
              if(seal!=null){
                uplines= uplines.map(l=>l.id==id?{...l,sealPath:'uploaded'}:l)
              }
              if(sign!=null){
                uplines= uplines.map(l=>l.id==id?{...l,signaturePath:'uploaded'}:l)
              }

             } else{
                /* if(pass!=null){
                    uplines= uplines.map(l=>l.id==id?{...l,passportPath:'uploaded'}:l)
                  } */
                  if(seal!=null){
                    uplines= uplines.map(l=>l.id==id?{...l,oathSealPath:'uploaded'}:l)
                  }
                  if(sign!=null){
                    uplines= uplines.map(l=>l.id==id?{...l,oathSignature:'uploaded'}:l)
                  }
                  if(stamp!=null){
                    uplines= uplines.map(l=>l.id==id?{...l,oathStamp:'uploaded'}:l)
                  }
             }

              setDocument({uplines});

             
        
    }

    const onSetImg =(path,type)=>{
        const ct=type.toLowerCase()
        if(ct=='seal'){
            setSeal(  `${Constants.docUrl}instrument/${path}`);
        }else if(ct=='passport'){
            setPassport(  `${Constants.docUrl}instrument/${path}`);
        }else if(ct=='signature'){
            setSign(  `${Constants.docUrl}instrument/${path}`);
        }else if(ct=='stamp'){
            setStamp(  `${Constants.docUrl}instrument/${path}`);
        }
        else if(ct=='initial'){
            setInitial(  `${Constants.docUrl}instrument/${path}`);
        }else if(ct=='cashier'){
            setCashierSeal( `${Constants.docUrl}instrument/${path}`);
        }
       /*  else if(ct=='timestamp'){
            setTimestamp(  `${Constants.docUrl}instrument/${path}`);
        } */
    }

    const onLoadInstrument= async()=>{
        //for account registration
        console.log(`the calling url ${urlInstrument}`);
        try {
            setIsLoading(true);
            const resp = await fetch(urlInstrument, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            });
            
            const data = await resp.json();
            setIsLoading(false);
            if(data.code==0){
                //check if it contain any of the items
                console.log('the loaded instrument');
                console.log(data);
                for( const x of data.inst ){
                    onSetImg(x.instPath, x.instrument)
                }
                
            }else if(data.code==-10){
                setIsExpired(true);
            }
            
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }

    const onSavePostion= ()=>{
         setPrompt({icon:'info',open:true,title:'Save Instrument Positioning', subtitle:'Please note that saving instrument positioning will modify the document and the process is not reversable. Do you want to continue?',
        onCancel:()=>{setPrompt({...prompt, open:false})}, onOk:onAppendOnServer}); 
    }

    const onNextPage=()=>{
        if(pageIndex < currectdoc.filenames.length-1){
            var ipage=pageIndex+1;
            setPageIndex(ipage);
        }else{
            console.log('its not there again '+pageIndex);
        }
    }

    const onPrevPage=()=>{
         if(pageIndex > 0){
            var ipage=pageIndex-1;
            setPageIndex(ipage);
        }else{
            console.log('its not there again '+pageIndex);
        }
    }

    const onAllowSign =(e)=>{
        console.log(e.target.value);
        onAllow(true, 'sign');

    }
    const onAllowSeal =(e)=>{
        console.log(e.target.value);
        onAllow(true, 'seal');
    }

    const onAllow=(isAllow, instType)=>{
        const url=`${Constants.apiUrl}/filing/allowinstrument/${currectdoc.upline?.id}`;
        var ll={uplineId:currectdoc.upline?.id,isAllow, instType, cfoUserid: profile.username  }
        setIsLoading(true); 
         
            fetch(url, {
            method: 'POST',
            body: JSON.stringify(ll),
            headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            },
            })
            .then(response => response.json())
            .then(data => {
                setIsLoading(false); 
                if(data.code==0){
                    //saved already
                   if(instType=='seal'){
                    var up=currectdoc.upline;
                    up.allowSeal=isAllow;
                    setCurrentDoc({...currectdoc, upline:up})
                   }
                   else if(instType=='sign'){
                    var up=currectdoc.upline;
                    up.allowSign=isAllow;
                    setCurrentDoc({...currectdoc, upline:up})
                   }
             

                }else if(data.code==-10){
                setIsExpired(true);
            }
            })
            .catch(error => {
                console.error('Error:', error)
                setIsLoading(false); 
            });
    }

    
    //about image and its rendered
 
  const [dynamicWidth, setDynamicWidth] = useState(650);
  const staticHeight=900;
  const [aspectRatio, setAspectRatio] = useState(null);
  const handleImageLoad = () => {
    console.log(`inside handleImageLoad before the core`)
    console.log(imageRef.current);
    if (imageRef.current) {
        const { naturalWidth, naturalHeight } = imageRef.current;
        console.log(`${naturalWidth}, ${naturalHeight}`)
      setAspectRatio((naturalWidth / naturalHeight).toFixed(2));
      console.log(`client width ${imageRef.current.clientWidth}`)
      //setDynamicWidth(imageRef.current.clientWidth);
      setTimeout(() => {
      const width = imageRef.current?.clientWidth || 0;
      console.log(`client width ${width}`);
      if(width>0){
        setDynamicWidth(width);
      }
      
    }, 0);
    }
  };

 /*  useEffect(() => {
  if (imageRef.current) {
    console.log(`inside resize oberver for imageRef`)
    const observer = new ResizeObserver(() => {
      setDynamicWidth(imageRef.current.clientWidth);
    });
    observer.observe(imageRef.current);

    return () => observer.disconnect();
  }
}, []); */
  //end image rendered
  return (
    <div className='view-doc'>
        
        <div className="body">
           
            
            <div className="document">
                <div className="doc-side">
                    <div className="top-bar">
                      
                        <div className="namedoc">
                            <p>Current File: <span>{currectdoc.upline?.documentTitle}</span> </p>
                        </div>
                     
                    </div>  
                    <div className="wrapper" style={{width:dynamicWidth, maxHeight:staticHeight,  backgroundColor:'GrayText', padding:0, position:'relative', alignSelf:'center', overflow:"auto"}}
                     ref={pageRef}  >
                      
                      
                        
                       {currectdoc.filenames.length>0 && <img ref={imageRef} onLoad={handleImageLoad} src={Constants.AbsoluteFiletoRelative(pdfdoc.filenames[pageIndex])} style={{ height:staticHeight,margin:0}} />} 
                       {currectdoc.filenames.length==0 && <h2>You are yet to upload the file. Goto the link <Link to={`/upload/documents/${item.caseFeeId}`}><span>Upload Files</span> </Link> </h2>}
                    
                    { imgs.map((item, id) => { return ( item.pageIndex==pageIndex &&
                           <div key={id}>
                           {(item.id==5 || item.id==7)?<div style={{height: 100,margin:0, position:'absolute', top:item.y, left:item.x}}  draggable onDrag={(e)=>onDrag(e,item.id)} 
                           onDragStart={(e)=>onDragStart(e,item.id)} onDragEnd={(e)=>onDragEnd(e,item.id)}><strong>{moment(currentdate).format("YYYY-MM-DD hh:mm a")}</strong> </div>: 
                           <img src={item.imgurl} style={{ height:100,margin:0, position:'absolute', top:item.y, left:item.x}} draggable onDrag={(e)=>onDrag(e,item.id)} 
                           onDragStart={(e)=>onDragStart(e,item.id)} onDragEnd={(e)=>onDragEnd(e,item.id)} />}  
                           
                           </div>
                        )})}
                     
                       
                    </div>
                </div>
               
                 <div className='actions'>
                    <p className="title">e-Swearing Quick Actions </p>  
                    { !isLegal && permissionList.has(currectdoc.upline?.gazetteItemId) && <div className='check-sign'>
                        <div>
                            <input type="checkbox" id='check-cfo' checked={currectdoc.upline?.allowSign} disabled={currectdoc.upline?.allowSign} onChange={(e)=> onAllowSign(e)} />
                            <label htmlFor="check-cfo" >Allow to Append Signature</label>
                        </div>
                        <div>
                            <input type="checkbox" checked={currectdoc.upline?.allowSeal} id='check-cfo'  disabled={currectdoc.upline?.allowSeal} onChange={(e)=> onAllowSeal(e)}/>
                            <label htmlFor="check-cfo">Allow to Append Seal</label>
                        </div>
                        
                    </div> } 
                    
                        {permissionList.has(currectdoc.upline?.gazetteItemId) && <div>{(currectdoc.upline?.allowSign && currectdoc.upline?.allowSeal)?<span style={{color:green[500], fontWeight:'bold'}}>permission granted for you to append your signature/seal </span> :<span style={{color:red[500], fontWeight:'bold'}}>Permission required for item </span>}</div>}
                    <div> 
                    {isLegal ?
                    <div className="btns" style={{flexWrap:'wrap'}}>
                            <div className="append">
                                <img src={seal==''? Seal : seal} alt="Seal" style={{ height:100}} />
                                <div className="btn-upload">
                                    <input type="file" id="append-seal" accept="image/*" onChange={(e)=>previewImage(e,"Seal") } />
                                    <label  htmlFor={`append-seal`}>Upload Seal</label>
                                </div>
                                <JisButton className='black' onClick={onAppendSeal}>Append Seal</JisButton>
                            </div> 
                          <div className="append">
                                <img src={sign==''? Sign:sign} alt="Signature"  style={{ height:100}}/>
                                <div  className="btn-upload">
                                    <input type="file" id="append-sign"  accept="image/*" onChange={(e)=>previewImage(e,"Signature") } />
                                    <label  htmlFor={`append-sign`}>Upload Sign</label>
                                </div>
                                <JisButton className='black' onClick={onAppendSignature}>Append Signature</JisButton>
                            </div>  
                           

                            <div className="append">
                                <img src={passport==''? Sign:passport} alt="Passport"  style={{ height:100}} />
                                <div className="btn-upload">
                                    <input type="file" id="append-passport"  accept="image/*" onChange={(e)=>previewImage(e,"Passport") } />
                                    <label  htmlFor={`append-passport`}>Upload Password</label>
                                </div>
                                <JisButton className='black' onClick={onAppendPassport}>Append Passport</JisButton>
                            </div>

                            <div className="append">
                                <img src={stamp==''? Sign:stamp} alt="Stamp"  style={{ height:100}}/>
                                <div className="btn-upload">
                                    <input type="file" id="append-stamp"  accept="image/*" onChange={(e)=>previewImage(e,"Stamp") } />
                                    <label  htmlFor={`append-stamp`}>Upload Stamp</label>
                                </div>
                                <JisButton className='black' onClick={onAppendStamp}>Append Stamp</JisButton>
                            </div>
                             <div className="append">
                               
                                <div style={{width:100, height:100}}></div>
                                <div className="append-create">
                                    <input type="text" id="append-time-stamp" value={moment(currentdate).format("YYYY-MM-DD hh:mm a")} disabled={true}  />
                                    
                                </div>
                                <JisButton  onClick={onAppendTimestamp}>Append Timestamp</JisButton>
                            </div>
                         
                        </div>:
                        <div className="btns"  style={{flexWrap:'wrap'}}>
                             <div className="append">
                                <img src={seal==''? Seal : seal} alt="Seal" style={{ height:100}} />
                                <div className="btn-upload">
                                    <input type="file" id="append-seal" accept="image/*" onChange={(e)=>previewImage(e,"Seal") } />
                                    <label  htmlFor={`append-seal`}>Upload Seal</label>
                                </div>
                                <JisButton  onClick={onAppendSeal}>Append {isCfo && 'CFO'} Seal</JisButton>
                            </div> 
                            <div className="append">
                                <img src={cashier_seal} alt="Cashier Seal" style={{ height:150}} />
                               
                                <JisButton  onClick={onAppendCashierSeal}>Append Cashier Seal</JisButton>
                            </div> 
                            <div className="append">
                                <img src={cashier_stamp} alt="Cashier Stamp" style={{ height:150}} />
                               
                                <JisButton  onClick={onAppendCashierStamp}>Append Cashier Stamp</JisButton>
                            </div> 
                           <div className="append">
                                <img src={sign==''? Sign:sign} alt="Signature"  style={{height:100}}/>
                                <div className="btn-upload">
                                    <input type="file" id="append-sign"  accept="image/*" onChange={(e)=>previewImage(e,"Signature") } />
                                    <label  htmlFor={`append-sign`}>Upload Sign</label>
                                </div>
                                <JisButton  onClick={onAppendSignature}>Append CFO Signature</JisButton>
                            </div>  

                            <div className="append">
                                <img src={initial==''? Sign:initial} alt="Initial"  style={{ height:100}}/>
                                <div className="btn-upload">
                                    <input type="file" id="append-sign"  accept="image/*" onChange={(e)=>previewImage(e,"Initial") } />
                                    <label  htmlFor={`append-sign`}>Upload Sign</label>
                                </div>
                                <JisButton  onClick={onAppendInitial}>Append CFO Initial</JisButton>
                            </div>  

                             <div className="append">
                                <img src={stamp==''? Sign:stamp} alt="Stamp"  style={{ height:100}}/>
                                <div className="btn-upload">
                                    <input type="file" id="append-stamp"  accept="image/*" onChange={(e)=>previewImage(e,"Stamp") } />
                                    <label  htmlFor={`append-stamp`}>Upload Stamp</label>
                                </div>
                                <JisButton className='black' onClick={onAppendStamp}>Append {isCfo && 'CFO'} Stamp</JisButton>
                            </div>
                             <div className="append">
                               
                                <div style={{ height:100}}></div>
                                <div className="append-create">
                                    <input type="text" id="append-time-stamp" value={moment(currentdate).format("YYYY-MM-DD hh:mm a")} disabled={true}  />
                                    
                                </div>
                                <JisButton className='black' onClick={onAppendTimestamp}>Append Timestamp</JisButton>
                            </div>
                            <div className="append">
                               
                               <div style={{height:100}}></div>
                               <div className="append-create">
                                   <input type="text" id="append-time-stamp" value={moment(currentdate).format("YYYY-MM-DD hh:mm a")} disabled={true}  />
                                   
                               </div>
                               <JisButton className='black' onClick={onAppendTimestamp2}>Append Timestamp 2</JisButton>
                           </div>

                        </div> }     
                        
                       
                   
                    
                    </div>
                    
                    <div className='groupbtn'>
                        <JisButton className='black' onClick={onSavePostion}>Save Instrument Positioning</JisButton>
                    </div>
                    <div>
                         <p style={{color:'red'}}><DynamicIcon iname="info" /> Click this button after appending all media to each document before moving to the next document </p>
                    </div>  
                </div>
            </div>
            <div className="down" style={{width:"50%"}}>

                {currectdoc.filenames.length==0 && <Link to={`/upload/documents/${item.caseFeeId}`}><span>Upload Files</span> </Link>}
                {currectdoc.filenames.length>0 && <div style={{display:'flex',justifyContent:'space-between'}}> <strong style={{fontSize:16, margin:16}}>{pageIndex+1 } / {currectdoc.filenames.length}</strong> 
        
                    <button onClick={onPrevPage} className='planred'>Previous Page</button>
                    <button  onClick={onNextPage} type='button' className='planred'>Next Page</button></div>} 

                {isCfo && <button onClick={() => setIsDialog(true)}>Edit Schedule </button> }
                { isThirdOpt && <button onClick={() => confirmCaseDoc()}>Confirm Document</button> }
            </div>
        </div>
      {cfoWarn && <div className={   'warning show' }>
            <div className="container">
                <div className="icon" onClick={() => setCfoWarn(false)}>
                     <DynamicIcon iname='close'/>
                </div>
                <div className="body">
                    <h3>Appending Signature</h3>
                    <p>You are not allowed to upload your signature yet. Please wait for the Chief for Oath (CFO) authorizes you to upload your signature. In the mean time, you can upload your seal and passport </p>
                    <button onClick={() => setCfoWarn(false)}>Ok</button>
                </div>
            </div>
        </div> }  
       
        <BackLoader open={isLoading}  />
        <JisPrompt {...imgPrev} onOk={onAgree}>
            <p style={{flexDirection:'row', alignContent:'center', alignItems:'center'}}>
           {imgPrev.data!=null && <img src={imgPrev.data} style={{height:100}} alt={imgPrev.type} />}     
                <strong>Are you ready to save this {imgPrev.type} {imgPrev.file?.name} ?</strong>
            </p>
        </JisPrompt>
       {alert.open && <JisAlert {...alert} />} 
        <JisPrompt {...prompt}>
            
            <p>{prompt.subtitle}</p>
        </JisPrompt>
    </div>
  )
}

export default JisPreparePdf